<script setup lang="ts">
import type { RouterLinkProps } from "vue-router";

defineProps<{
  to: RouterLinkProps["to"];
}>();
</script>

<template>
  <RouterLink
    :to="to"
    class="text-indigo-600 hover:text-indigo-900"
  >
    <slot class="font-medium" />
  </RouterLink>
</template>
